import { render, staticRenderFns } from "./LoginCode.vue?vue&type=template&id=12e6ba2b&"
import script from "./LoginCode.vue?vue&type=script&lang=js&"
export * from "./LoginCode.vue?vue&type=script&lang=js&"
import style0 from "./LoginCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports